@if (productReplacement$ | async; as product) {
<div class="replacement-product-wrapper">
  @if (product.replacedBy) {
  <ng-template [cxOutlet]="outlets.REPLACEDBY" [cxOutletContext]="{ product: product }">
    <div class="replacement-product replaced-by js-replaced-by">
      <div class="replacement-product-image-wrapper {{ product?.replacedBy?.thumbnail == null ? 'is-missing' : '' }}">
        <img class="replacement-product-image" [src]="getImageRendition(product?.replacedBy?.thumbnail)" />
      </div>
      <div class="replacement-product-area">
        <span class="replacement-product-title"
          >{{ 'product.replacedby' | cxTranslate }}
          @if (product['replacedByNotice']) {
          <mat-icon
            [matTooltip]="product['replacedByNotice']"
            [matTooltipPosition]="'above'"
            matTooltipClass="cart-delete-entry"
            aria-label="displays a tooltip in above"
            svgIcon="info-black"
            (mouseenter)="$event.stopImmediatePropagation()"
            (mouseleave)="$event.stopImmediatePropagation()"
            #tooltip="matTooltip"
            (click)="tooltip.toggle()"
          ></mat-icon>
          }
        </span>
        <a tabindex="0" class="pdp-link" [routerLink]="{ cxRoute: 'product', params: product.replacedBy } | cxUrl">
          <p [innerHTML]="product?.replacedBy?.name" class="replacement-product-text"></p>
        </a>
      </div>
    </div>
  </ng-template>
  } @if (product.replacementOf) {
  <ng-template [cxOutlet]="outlets.REPLACEMENTOF" [cxOutletContext]="{ product: product }">
    <div class="replacement-product replacement-of js-replacement-of">
      <div
        class="replacement-product-image-wrapper {{ product?.replacementOf?.thumbnail == null ? 'is-missing' : '' }}"
      >
        <img class="replacement-product-image" [src]="getImageRendition(product?.replacementOf?.thumbnail)" />
      </div>
      <div class="replacement-product-area">
        <span class="replacement-product-title"
          >{{ 'product.replacementof' | cxTranslate }}
          @if (product['replacementOfNotice']) {
          <mat-icon
            [matTooltip]="product['replacementOfNotice']"
            [matTooltipPosition]="'above'"
            matTooltipClass="cart-delete-entry"
            aria-label="displays a tooltip in above"
            svgIcon="info-black"
            (mouseenter)="$event.stopImmediatePropagation()"
            (mouseleave)="$event.stopImmediatePropagation()"
            #tooltip="matTooltip"
            (click)="tooltip.toggle()"
          ></mat-icon>
          }
        </span>
        <a tabindex="0" class="pdp-link" [routerLink]="{ cxRoute: 'product', params: product.replacementOf } | cxUrl">
          <p [innerHTML]="product?.replacementOf?.name" class="replacement-product-text"></p>
        </a>
      </div>
    </div>
  </ng-template>
  }
</div>
}
